import makeIo from './make-io'

export default function SPLENDID_CONTOURS() {
  const holders = [...document.querySelectorAll('img.ImageHolder')]
  const io = makeIo(callback)

  holders.forEach((holder) => {
    io.observe(holder)
  })
}

/**
 * When ImageHolder comes into view.
 * @param {Element} target
 */
const callback = (target) => {
  const noscript = /** @type {!HTMLElement} */ (target.nextElementSibling)
  if (noscript.tagName != 'NOSCRIPT') {
    return console.warn('sibling not a noscript')
  }
  const picture = document.createElement('picture')
  target.parentElement.insertBefore(picture, target.nextSibling)
  let st = ''
  const html = noscript.textContent
    .replace(/(<picture[^>]+?)style="([^"]*?)"/, (m, g, s) => {
      st = s
      return g
    })
    .replace('<picture ', `<picture style="${[st, 'display:none!important'].filter(Boolean).join(';')}" `)

  // picture._initialStyle = st
  picture.outerHTML = html
  noscript.parentElement.removeChild(noscript)
}

/**
 * @param {!Element} object
 */
const hideObject = (object, seconds) => {
  object.style.animation = object.style.webkitAnimation = `contourFadeOut ${seconds}s ease-out`
  setTimeout(() => {
    object.style.setProperty('opacity', '0')
    object.style.animation = object.style.webkitAnimation = ''
    // object.parentElement.removeChild(object)
    object['_finishedAppear'] = true
  }, seconds * 1000)
}

/**
 * The callback for when webp is loaded.
 * @param {HTMLImageElement} img
 */
window['webploaded'] = (img) => {
  const picture = /** @type {HTMLPictureElement} */ (img.parentElement)
  const oid = `o${picture.id}`
  const o = document.getElementById(oid)
  if (o) hideObject(o, 7)

  const svg = picture.previousElementSibling
  svg['_picture'] = picture.querySelector('img')
  svg.parentElement.removeChild(svg)

  picture.style.cssText = picture.style.cssText.replace(/;?\s*display:\s*none\s*!important;?$/, '')
  picture.style.animation = picture.style.webkitAnimation = 'fadeInFromNone 2.5s ease-out'
}
